import React from "react";

const ExtraSection = ({ extraSectionRef, showExtraSection, content }) => {
  return (
    <div
      ref={extraSectionRef}
      style={{ backgroundColor: "#ffffff", padding: 0 }}
    >
      <div className="container-fluid">
        <div className="row g-0 align-items-stretch">
          {/* Left image column */}
          <div className="col-md-6" style={{ overflowX: "hidden" }}>
            <div
              style={{
                transform: showExtraSection
                  ? "translateX(0)"
                  : "translateX(-100px)",
                opacity: showExtraSection ? 1 : 0,
                transition: "all 1s ease-out",
              }}
            >
              <img
                src={content.image}
                alt="Extra Visual"
                className="Team-Filipino"
              />
            </div>
          </div>

          {/* Right text column */}
          {/* Right text column */}
          <div
            className="col-md-6 d-flex align-items-center"
            style={{ overflowX: "hidden" }}
          >
            <div
              className="w-100"
              style={{
                transform: showExtraSection
                  ? "translateX(0)"
                  : "translateX(100px)",
                opacity: showExtraSection ? 1 : 0,
                transition: "all 1s ease-out",
                backgroundColor: "#ffffff",
              }}
            >
              <div
                className="text-white p-5 d-flex flex-column justify-content-center"
                style={{
                  backgroundColor: "#011601",
                  minHeight: "100%", 
                  height: "100%", 
                }}
              >
                <h4 className="fw-bold mb-3">{content.heading}</h4>
                <p className="mb-0">{content.paragraph}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExtraSection;
